import { environment } from '@quartz-gov-legacy/environments/environment';
﻿
(function () {
    'use strict';

    angular
        .module('iamSystemModule')
        .factory('iamSystemService', service);

    service.$inject = ['$http'];

    function service($http) {
        var baseUrl = environment.apiUrl + '/Pilot/api/IAMSystem/';

        function returnData(response) {
            return response.data;
        }

        var service = {};

        // IAM System by slug
        service.getBySlug = function (slug) {
            var endpoint = 'By/Slug/';
            return $http
                .get(baseUrl + endpoint + slug, { ignoreError: true })
                .then(returnData);
        };

        return service;
    }
})();
